import { useStore } from '@nanostores/react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { appendReturnTo } from '@/app/router/returnTo';
import { sessionStore } from '@/entities/session';
import { PhoneOtpLogin } from '@/features/auth';

import { LoginShell } from './LoginShell';

function LoginPage() {
  const session = useStore(sessionStore);
  const [searchParams] = useSearchParams();

  if (session.status === 'authenticated') {
    const returnTo = searchParams.get('returnTo');
    return <Navigate to={appendReturnTo('/clinician', returnTo)} replace />;
  }

  return (
    <LoginShell>
      <PhoneOtpLogin title="Join physicians using Cortex" className="w-full px-10" />
    </LoginShell>
  );
}

export default LoginPage;
